export default "/images/crypto_environments/ethereum__smart_contract__icon.png";